/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Tooltip from '@mui/material/Tooltip';
import React, { ReactNode } from 'react';
import Popover from '@mui/material/Popover';
import useMediaQuery from '@mui/material/useMediaQuery';

import styles from './Badge.module.scss';

interface BadgeProps {
  className?: string;
  children: ReactNode;
  title?: string;
  id: string;
  variant?: 'new' | 'old'; // Defaults to old style
  'data-doc-state'?: string;
}

export function Badge({ className, children, id, title, variant, 'data-doc-state': dataDocState }: BadgeProps) {
  const [open, setOpen] = React.useState(false);
  const compact = useMediaQuery('(max-width: 1000px)');
  return (
    <>
      <div
        className={`${styles.container} ${className}`}
        onClick={() => setOpen(compact && !!title)}
        id={id}
        data-doc-state={dataDocState}
        aria-owns={open ? `${id}-popover` : undefined}
        aria-haspopup="true"
      >
        <Tooltip title={title || ''} placement="top" arrow enterDelay={800} disableInteractive disableTouchListener>
          <div>{children}</div>
        </Tooltip>
      </div>
      <Popover
        open={open}
        id={`${id}-popover`}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        onClose={() => setOpen(false)}
      >
        <div className={styles.tooltipMobile} onClick={() => setOpen(false)}>
          <div>{title}</div>
        </div>
      </Popover>
    </>
  );
}
